import * as ActionTypes from 'constants';

export const setNotifications = notifications => ({ type: ActionTypes.SET_NOTIFICATIONS, payload: { notifications }});
export const updateNotification = notification => ({ type: ActionTypes.NOTIFICATION_UPDATED, payload: { notification }});
export const removeNotification = notification_id => ({ type: ActionTypes.REMOVE_NOTIFICATION, payload: { notification_id }});
export const clearNotifications = f => ({ type: ActionTypes.CLEAR_NOTIFICATIONS });



// WEBPACK FOOTER //
// ./src/common/actions/notifications.js